import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a restaurant booth bench 1.0 x 0.6: seat at 0.45, high
// upholstered back to 1.2, muted-red vinyl on a walnut plinth, facing +Z.
const VINYL = "#a05548";
const VINYL_DARK = "#8c4a3f";
const PLINTH = "#7a5a3a";

export const boothSeat = defineModel({
  id: "booth-seat",
  batchId: "modern",
  name: "Booth seat",
  tags: ["modern", "interior", "furniture", "restaurant", "seating", "booth"],
  summary: "A high-backed restaurant booth bench in muted-red vinyl.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // walnut plinth
      { geometry: new THREE.BoxGeometry(0.96, 0.12, 0.52), color: PLINTH, position: [0, 0.06, 0.02] },
      // bench base
      { geometry: new THREE.BoxGeometry(1.0, 0.22, 0.5), color: VINYL_DARK, position: [0, 0.23, 0.03] },
      // seat cushion (top at 0.45)
      { geometry: new THREE.BoxGeometry(1.0, 0.11, 0.46), color: VINYL, position: [0, 0.395, 0.07] },
      // high back (rises to 1.2)
      { geometry: new THREE.BoxGeometry(1.0, 0.86, 0.16), color: VINYL_DARK, position: [0, 0.77, -0.22] },
      // back cushion panel
      { geometry: new THREE.BoxGeometry(1.0, 0.62, 0.06), color: VINYL, position: [0, 0.72, -0.11] },
      // top cap rail
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.18), color: VINYL, position: [0, 1.17, -0.22] },
    ];
  },
  animations: [],
});
